module.exports = __webpack_public_path__ + "img/nosotros-envases.47b7421e.webp";